import React from "react";
import { Form } from "react-bootstrap";

function HotelRegistration_step_3({ register, errors, setValue }) {
  return (
    <>
      <h5 className="step-heading">
        C. Company Details (Internship Agreement)
      </h5>
      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Establishment Name</Form.Label>
              <Form.Control
                placeholder="Establishment Name"
                {...register("establishment_name", {
                  required: "Establishment Name is required",
                  maxLength: {
                    value: 100,
                    message: "Establishment Name cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.establishment_name && (
                <Form.Text className="text-danger">
                  {errors?.establishment_name?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Website URL</Form.Label>
              <Form.Control
                placeholder="Website URL"
                {...register("establishment_web_url", {
                  required: "Website URL is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid Website URL Address",
                  },
                })}
              />
              {errors?.establishment_web_url && (
                <Form.Text className="text-danger">
                  {errors?.establishment_web_url?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>Internship Location Address</Form.Label>
              <Form.Control
                as="textarea"
                role="2"
                placeholder="Internship Location Address"
                {...register("establishment_address", {
                  required: "Internship Location Address is required",
                })}
              />
              {errors?.establishment_address && (
                <Form.Text className="text-danger">
                  {errors?.establishment_address?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>Establishment Address</Form.Label>
              <Form.Control
                as="textarea"
                role="2"
                placeholder="Establishment Address"
                {...register("establishment_current_address", {
                  required: "Internship Establishment Address is required",
                })}
              />
              {errors?.establishment_current_address && (
                <Form.Text className="text-danger">
                  {errors?.establishment_current_address?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>Internship Accommodation Street</Form.Label>
              <Form.Control
                as="textarea"
                role="2"
                placeholder="Internship Accommodation Street"
                {...register("accomodation_street", {
                  required: "Internship Accommodation Street is required",
                })}
              />
              {errors?.accomodation_street && (
                <Form.Text className="text-danger">
                  {errors?.accomodation_street?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>Internship Accommodation Postal Code</Form.Label>
              <Form.Control
                as="textarea"
                role="2"
                placeholder="Internship Accommodation Postal Code"
                {...register("accomodation_postal_code", {
                  required: "Internship Accommodation Postal Code is required",
                })}
              />
              {errors?.accomodation_postal_code && (
                <Form.Text className="text-danger">
                  {errors?.accomodation_postal_code?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>Internship Accommodation City</Form.Label>
              <Form.Control
                as="textarea"
                role="2"
                placeholder="Internship Accommodation Country"
                {...register("accomodation_country", {
                  required: "Internship Accommodation Country is required",
                })}
              />
              {errors?.accomodation_country && (
                <Form.Text className="text-danger">
                  {errors?.accomodation_country?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>Internship Accommodation City</Form.Label>
              <Form.Control
                as="textarea"
                role="2"
                placeholder="Internship Accommodation City"
                {...register("accomodation_city", {
                  required: "Internship Accommodation City is required",
                })}
              />
              {errors?.accomodation_city && (
                <Form.Text className="text-danger">
                  {errors?.accomodation_city?.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </>
  );
}

export default HotelRegistration_step_3;
